module.exports = __webpack_public_path__ + "static/media/relocation.b5212120.jpg";